import { gql } from "@apollo/client";

export const UPDATE_COMPANY = gql`
    mutation UpdateCompany(
        $name: String
        $employeeCount: Int
        $description: String
        $locations: [String]
        $websites: [String]
    ) {
        updateCompany(
            name: $name
            employeeCount: $employeeCount
            description: $description
            locations: $locations
            websites: $websites
        ) {
            id
            name
            createdAt
            updatedAt
            ownerId
            details {
                id
                description
                employeeCount
                metadata
            }
        }
    }
`;